// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newsheader {
  margin: 16px;
  font-style: times;
}

.viewallbutton {
  margin: 8px;
  margin-top: 16px;
  padding-left: 10px;
  padding-right: 10px;
  border: none;
  /* border: 2px solid #DD2C00; */
  border-radius: 20px;
  background: white;
  color: #dd2c00;
}

.viewallbutton:hover {
  background: #dd2c00;
  color: white;
}

.news-slider {
  position: relative;
  width: 98%;
}

.mySlides {
  display: none;
  margin-left: 20px;
  width: 116%;
}

.pre,
.nex {
  cursor: pointer;
  position: absolute;
  top: 50%;
  width: auto;
  padding: 16px;
  margin-top: -22px;
  color: red;
  font-weight: bold;
  font-size: 18px;
  transition: 0.6s ease;
  border-radius: 0 3px 3px 0;
  -webkit-user-select: none;
          user-select: none;
  background-color: white;
  box-shadow: 1px 2px 10px -1px rgba(0, 0, 0, 0.3);
}

.nex {
  right: 0;
  border-radius: 3px 0 0 3px;
  margin-right: 0px;
}

.pre {
  margin-left: -23px;
}

.fad {
  -webkit-animation-name: fade;
  -webkit-animation-duration: 1.5s;
  animation-name: fade;
  animation-duration: 1.5s;
}
@keyframes fade {
  from {
    opacity: 0.4;
  }
  to {
    opacity: 1;
  }
}
.newsdetails {
  word-wrap: break-word;
  overflow: hidden;
  height: 60px;
  line-height: 20px;
  white-space: pre-wrap;
}

.pre1,
.nex1 {
  cursor: pointer;
  position: absolute;
  top: 10%;
  font-weight: bold;
  font-size: 18px;
  transition: 0.6s ease;
  -webkit-user-select: none;
          user-select: none;
  background-color: #eee;
  box-shadow: 1px 2px 10px -1px rgba(0, 0, 0, 0.3);
  outline: none;
}

.nex1 {
  right: 0;
  margin-right: 0px;
}

.pre1 {
  margin-left: -23px;
}

.newscontent {
  width: 100%;
}

.buttonRepo:hover {
  background-color: #c3c0bf;
  color: white;
}

.newsdetails button {
  display: table-cell;
  margin-left: 10px;
  font-size: 14px;
  margin-bottom: 8px;
  outline: none;
  width: 220px;
  padding-left: 5px;
  padding-right: 5px;
  white-space: pre-wrap;
  height: 50px;
  line-height: 20px;
}

.activeBtn {
  background-color: #c3c0bf;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/carousel/carousel.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,+BAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;AACF;;AAEA;EACE,aAAA;EACA,iBAAA;EACA,WAAA;AACF;;AAEA;;EAEE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,0BAAA;EACA,yBAAA;UAAA,iBAAA;EACA,uBAAA;EACA,gDAAA;AACF;;AAEA;EACE,QAAA;EACA,0BAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,4BAAA;EACA,gCAAA;EACA,oBAAA;EACA,wBAAA;AACF;AAYA;EACE;IACE,YAAA;EADF;EAIA;IACE,UAAA;EAFF;AACF;AAKA;EACE,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;AAHF;;AAMA;;EAEE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,sBAAA;EACA,gDAAA;EACA,aAAA;AAHF;;AAMA;EACE,QAAA;EACA,iBAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAMA;EACE,WAAA;AAHF;;AAMA;EACE,yBAAA;EACA,YAAA;AAHF;;AAMA;EACE,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;AAHF;;AAMA;EACE,yBAAA;AAHF","sourcesContent":[".newsheader {\n  margin: 16px;\n  font-style: times;\n}\n\n.viewallbutton {\n  margin: 8px;\n  margin-top: 16px;\n  padding-left: 10px;\n  padding-right: 10px;\n  border: none;\n  /* border: 2px solid #DD2C00; */\n  border-radius: 20px;\n  background: white;\n  color: #dd2c00;\n}\n\n.viewallbutton:hover {\n  background: #dd2c00;\n  color: white;\n}\n\n.news-slider {\n  position: relative;\n  width: 98%;\n}\n\n.mySlides {\n  display: none;\n  margin-left: 20px;\n  width: 116%;\n}\n\n.pre,\n.nex {\n  cursor: pointer;\n  position: absolute;\n  top: 50%;\n  width: auto;\n  padding: 16px;\n  margin-top: -22px;\n  color: red;\n  font-weight: bold;\n  font-size: 18px;\n  transition: 0.6s ease;\n  border-radius: 0 3px 3px 0;\n  user-select: none;\n  background-color: white;\n  box-shadow: 1px 2px 10px -1px rgba(0, 0, 0, 0.3);\n}\n\n.nex {\n  right: 0;\n  border-radius: 3px 0 0 3px;\n  margin-right: 0px;\n}\n\n.pre {\n  margin-left: -23px;\n}\n\n.fad {\n  -webkit-animation-name: fade;\n  -webkit-animation-duration: 1.5s;\n  animation-name: fade;\n  animation-duration: 1.5s;\n}\n\n@-webkit-keyframes fade {\n  from {\n    opacity: 0.4;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fade {\n  from {\n    opacity: 0.4;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n.newsdetails {\n  word-wrap: break-word;\n  overflow: hidden;\n  height: 60px;\n  line-height: 20px;\n  white-space: pre-wrap;\n}\n\n.pre1,\n.nex1 {\n  cursor: pointer;\n  position: absolute;\n  top: 10%;\n  font-weight: bold;\n  font-size: 18px;\n  transition: 0.6s ease;\n  user-select: none;\n  background-color: #eee;\n  box-shadow: 1px 2px 10px -1px rgba(0, 0, 0, 0.3);\n  outline: none;\n}\n\n.nex1 {\n  right: 0;\n  margin-right: 0px;\n}\n\n.pre1 {\n  margin-left: -23px;\n}\n\n.newscontent {\n  width: 100%;\n}\n\n.buttonRepo:hover {\n  background-color: #c3c0bf;\n  color: white;\n}\n\n.newsdetails button {\n  display: table-cell;\n  margin-left: 10px;\n  font-size: 14px;\n  margin-bottom: 8px;\n  outline: none;\n  width: 220px;\n  padding-left: 5px;\n  padding-right: 5px;\n  white-space: pre-wrap;\n  height: 50px;\n  line-height: 20px;\n}\n\n.activeBtn {\n  background-color: #c3c0bf;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
